import axios from 'axios';

import { buildApiV2Url } from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';

export default (collectionPath, entityId, { isFullWidth }) =>
  axios
    .patch(buildApiV2Url(`${collectionPath}/${entityId}`), {
      is_full_width: isFullWidth,
    })
    .catch(generateApiError());
